import type { TRoutingMap } from '@muse-web/router'
import { ScreenId } from '@core/router'
import { markLoadStage } from '@core/analytics'

const withChunkLoadedMark = (routingMap: TRoutingMap<void>): TRoutingMap<void> => {
    const marked: TRoutingMap<void> = { ...routingMap }

    Object.entries(routingMap).forEach(([screenId, loadChunk]) => {
        marked[screenId] = async () => {
            const chunk = await loadChunk()
            markLoadStage('screen_chunk_loaded')

            return chunk
        }
    })

    return marked
}

export const routes: TRoutingMap<void> = withChunkLoadedMark({
    [ScreenId.MP3_CUTTER]: () =>
        import(/* webpackChunkName: 'mp3-cutter-screen' */ '@screens/mp3-cutter'),
    [ScreenId.ERROR]: () => import(/* webpackChunkName: 'error-screen' */ '@screens/error'),
    [ScreenId.AUDIO]: () => import(/* webpackChunkName: 'audio-screen' */ '@screens/audio'),
    [ScreenId.AUDIO_NOT_FOUND]: () =>
        import(/* webpackChunkName: 'audio-not-found-screen' */ '@screens/audio-not-found'),
    [ScreenId.AUTH]: () => import(/* webpackChunkName: 'auth-screen' */ '@screens/auth'),
    [ScreenId.FORGOT_PASSWORD]: () =>
        import(/* webpackChunkName: 'forgot-password-screen' */ '@screens/forgot-password'),
    [ScreenId.BROWSE]: () => import(/* webpackChunkName: 'browse-screen' */ '@screens/browse'),
    [ScreenId.COLLECTION]: () =>
        import(/* webpackChunkName: 'collection-screen' */ '@screens/collection'),
    [ScreenId.SEARCH]: () => import(/* webpackChunkName: 'search-screen' */ '@screens/search'),
    [ScreenId.USER_AUDIO]: () =>
        import(/* webpackChunkName: 'user-audio-screen' */ '@screens/user-audio'),
    [ScreenId.USER_COLLECTIONS]: () =>
        import(/* webpackChunkName: 'user-collections-screen' */ '@screens/user-collections'),
    [ScreenId.AUDIO_UPLOAD]: () =>
        import(/* webpackChunkName: 'audio-upload-screen' */ '@screens/audio-upload'),
    [ScreenId.AUDIO_EDIT]: () =>
        import(/* webpackChunkName: 'audio-edit-screen' */ '@screens/audio-edit'),
})
